import { clientFetch } from "@/utils/service";
import { FETCH_PSYCHOLOGISTS } from './actionsTypes';

export const fetchPsychologistsApi = async (query) =>
  clientFetch('/admin/psychologists', { query });

export const fetchPsychologists = (query) => {
  return {
    type: FETCH_PSYCHOLOGISTS,
    payload: fetchPsychologistsApi(query),
  };
};
